import { Col, Row } from 'antd';
import { cloneDeep } from 'es-toolkit/object';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import FilterCard from '../../../../../components/Cards/FilterCard';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';
import ProvidersListCard from './ProvidersListCard';

const SpotBidProviderCard = ({ providers, distributionName, handleProvidersChange, actualIndex }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const [providerList, setProviderList] = useState(providers);
  const [providerSelectedAll, setProviderSelectedAll] = useState(false);
  const handleAllProvidersCheckbox = (e) => {
    const {
      target: { checked },
    } = e;
    let data = cloneDeep(providerList);
    if (checked) {
      data = data.map((row) => ({ ...row, selected: true }));
      setProviderList([...data]);
    } else {
      data = data.map((row) => ({ ...row, selected: false }));
      setProviderList([...data]);
    }
    setProviderSelectedAll(checked);
  };
  const handleProviderClick = (e, index) => {
    const {
      target: { checked },
    } = e;
    const data = cloneDeep(providerList);
    data[index].selected = checked;
    setProviderList([...data]);
  };

  const selectedProviderList = useMemo(() => providerList?.filter((provider) => provider.selected), [providerList]);

  useEffect(() => {
    setProviderSelectedAll(selectedProviderList.length === providerList.length);
    handleProvidersChange(providerList, actualIndex);
  }, [selectedProviderList]);

  return (
    <FilterCard
      title={
        <Row>
          <Col>
            <FormCheckBox
              checkBoxClass="normal-checkbox"
              label={
                <span>
                  <SecondaryLabel className=" mr-3">{`${t('translation:default.fields.distributor')}`}</SecondaryLabel>
                  <SecondaryLabel className="f-14 fw-600 ">{distributionName}</SecondaryLabel>
                </span>
              }
              className="m-0 "
              onChange={handleAllProvidersCheckbox}
              checked={providerSelectedAll}
            />
          </Col>
        </Row>
      }
      className="mb-16 overflow-hidden d-flex flex-direction-column"
      showBorder
    >
      <div className="flex-1 ">
        {providerList.map(({ key, ...rest }, idx) => (
          <ProvidersListCard
            providerDetails={rest}
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            key={idx}
            index={idx}
            selected={Boolean(providerList?.[idx]?.selected)}
            handleProviderClick={handleProviderClick}
            isLastItem={providerList.length === idx + 1}
          />
        ))}
      </div>
    </FilterCard>
  );
};

export default SpotBidProviderCard;
